import { render, staticRenderFns } from "./dark-mode-button.vue?vue&type=template&id=926d37a8&"
import script from "./dark-mode-button.vue?vue&type=script&lang=js&"
export * from "./dark-mode-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports